declare namespace $ {

	export class $shm_hitalama_quick_item extends $rise_drag_absolute {
		transition( ): string
		transition_smooth( ): string
		style( ): ({ 
			'transition': ReturnType< $shm_hitalama_quick_item['transition'] >,
		})  & ReturnType< $rise_drag_absolute['style'] >
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map